import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";

export const KeyColumn = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 4px;
  svg {
    margin-bottom: 2px;
    min-width: 14px;
  }
  span {
    max-width: 240px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: block;
  }
  button {
    padding: 4px;
    margin: 0 -4px;
    cursor: pointer;
    color: inherit;
    svg {
      margin-bottom: -2px;
    }
  }
  ${mediaQuery.isMobile} {
    span {
      max-width: 100px;
    }
  }
`;

export const ViewLyveModalContainer = styled.div`
  width: 100%;
  padding-right: 25px;
  > div {
    position: relative;
  }
`;

export const CopyButton = styled.button`
  position: absolute;
  left: 100%;
  top: 34px;
  padding: 9px 6px;
  font-size: ${calcRem(24)};
  color: ${({ theme }) =>
    theme.value === "light" ? COLORS.BLACK : COLORS.WHITE};
  svg {
    display: block;
  }
`;

export const FormItem = styled.div`
  ${FLEX.FlexBetweenStart};
  width: 100%;
  gap: 16px;
  label {
    padding: 10px 0;
  }
  input,
  .select-container,
  .ant-input-number {
    width: 276px;
    input {
      padding-left: 10px;
    }
  }
  input {
    padding: 9px 10px;
  }
`;

export const FormContainer = styled.div`
  ${FLEX.FlexStartCenter};
  flex-direction: column;
  width: 100%;
  gap: 17px;
  .common-modal-input {
    display: grid;
    grid-template-columns: 150px 1fr;
    align-items: stretch;
    label {
      ${FLEX.FlexStartCenter};
    }
    .validate-word {
      grid-column: 2 / 3;
    }
  }
`;

export const FormStorage = styled.div`
  ${FLEX.FlexStartCenter};
  width: 100%;
  gap: 6px;
  font-size: ${calcRem(14)};
  color: ${({ theme }) =>
    theme.value === "light" ? COLORS.BLACK : COLORS.WHITE}60;
  .ant-input-number {
    width: 100%;
    input {
      background: none !important;
      padding: 7px 15px;
    }
    &.ant-input-number-disabled {
      background-color: ${({ theme }) => theme.COLORS.DISABLED} !important;
      border-color: ${({ theme }) => theme.COLORS.DISABLED_BORDER} !important;
      input {
        color: ${({ theme }) =>
          theme.value === "light"
            ? `${theme.COLORS.WHITE}60`
            : theme.COLORS.LIGHTGRAY} !important;
        cursor: not-allowed;
      }
    }
  }
  > span {
    width: 100%;
  }
`;

export const StepButtonContainer = styled.div`
  ${FLEX.FlexCenterCenter};
  width: 100%;
  gap: 10px;
  padding-top: 40px;
`;

export const StepContainer = styled.div`
  padding: 20px 0;
  width: 100%;
  max-width: 440px;
`;

export const SuccessKeyContainer = styled.div`
  position: relative;
  width: 100%;
  button {
    position: absolute;
    left: 100%;
    top: 0;
    padding: 9px 6px;
    font-size: ${calcRem(24)};
    color: ${({ theme }) =>
      theme.value === "light" ? COLORS.BLACK : COLORS.WHITE};
  }
`;

export const SuccessContainer = styled.div`
  ${FLEX.FlexStartCenter};
  width: 100%;
  gap: 10px;
  flex-direction: column;
  color: ${({ theme }) =>
    theme.value === "light" ? COLORS.BLACK : COLORS.WHITE};
  p {
    width: 100%;
    font-weight: 500;
    padding-bottom: 15px;
  }
  b {
    ${FLEX.FlexStartCenter};
    gap: 8px;
    padding-bottom: 10px;
    font-weight: 600;
    svg {
      width: 20px;
      height: 20px;
      margin-top: -2px;
    }
  }
`;

export const SuccessButtonContainer = styled.div`
  ${FLEX.FlexEndCenter};
  width: 100%;
  gap: 10px;
`;

export const Column = styled.div<{
  isActive: boolean;
  underline?: boolean;
  isWhiteSpace?: boolean;
  percentage?: number;
}>`
  ${({ isActive, theme, percentage }) => {
    if (isActive) {
      if (percentage) {
        if (percentage > 95) {
          return `
            color: ${theme.COLORS.RED};
          `;
        }
        if (percentage > 85) {
          return `
            color: ${theme.COLORS.COMPANY};
          `;
        }
        if (percentage > 80) {
          return `
            color: ${theme.COLORS.YELLOW};
          `;
        }
        return `
          color: ${theme.COLORS.WHITE};
        `;
      }
      return `
        color: ${theme.COLORS.WHITE};
      `;
    }
    return `
      color: ${COLORS.BUTTONS1};
    `;
  }}

  ${({ isWhiteSpace }) =>
    isWhiteSpace &&
    `
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
  `}
  ${({ underline }) =>
    underline &&
    `
    cursor: pointer;
    text-decoration: underline;
  `}
`;

export const DurationColumn = styled(Column)<{ isFlowDuration: boolean }>`
  ${FLEX.FlexStartCenter};
  gap: 4px;
  ${({ isFlowDuration }) =>
    isFlowDuration &&
    `
    color: ${COLORS.RED};
  `}
`;
